//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const TIME_COUNT = 60
import { Toast } from 'vant';
import { getCgcc, getCheckCode } from '@/api/elizabeth'
export default {
  name: 'Elizabeth',
  data() {
    return {
        count: '',
            canSend: true,
            validateMobile: false,
            toLogin: false,
            loading: false,
            timer: null,
            userInfo: {
                mobile: '',
                vCode: '',
            },
    }
  },
  components: {
    [Toast.name]: Toast,
  },
  created() {
    this.getCgccFn()
  },
  methods: {
    getCgccFn(){
        getCgcc().then(res => {
            console.log(res)
        })
    },
    getCode(){

        if(this.userInfo.mobile == "" || this.userInfo.mobile.length !=11){ 
            Toast.fail('请填写正确的手机号码！')
            return
        }
        let params = {
            mobile: this.userInfo.mobile
        }
        getCheckCode(params).then(res => {
            console.log(res,'res')
            if(res.code == 200){
                Toast.success('验证码发送成功！')
                this.count = TIME_COUNT
                this.canSend = false
                this.timer = setInterval(() => {
                    this.count--
                    if(this.count <= 0){
                        this.count = TIME_COUNT
                        this.canSend = true
                    }
                }, 1000)
            }else{
                Toast({
                    message: res.message,
                    duration: 2000,
                    icon: 'none'
                })
            }
        })

    },
    submit(){
        if(this.userInfo.mobile == "" || this.userInfo.mobile.length !=11){ 
            Toast.fail('请填写正确的手机号码！')
            return
        }
        if(this.userInfo.vCode == "" || this.userInfo.vCode.length !=6){ 
            Toast.fail('请填写正确的验证码！')
            return
        }

        console.log('提交')
    }
  },
  destroyed(){
    clearInterval(this.timer)
  }
}




// WEBPACK FOOTER //
// ./src/view/elizabeth/index.vue